// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import purchaseStatusEntity from './entities/purchase-status.json';
import purchaseStatusMenu from '../pages/purchase-status/menu.json';
import purchaseStatusFullForm from '../pages/purchase-status/forms/full.json';
import purchaseStatusContextForm from '../pages/purchase-status/forms/context.json';
import purchaseStatusMiniForm from '../pages/purchase-status/forms/mini.json';
import purchaseStatusLookupForm from '../pages/purchase-status/forms/lookup.json';
import purchaseStatusTableView from '../pages/purchase-status/views/table.json';
import purchaseStatusDashboardView from '../pages/purchase-status/views/dashboard.json';

/** Тип запису «Статус закупівлі» зі сторінками пакета: меню, форми та подання з pages/purchase-status/. */
export const purchaseStatusDefinition: IRecordTypeDefinition = {
  ...purchaseStatusEntity,
  views: assembleViewSet({
      table: purchaseStatusTableView,
      dashboard: purchaseStatusDashboardView,
  }),
  form: purchaseStatusFullForm,
  forms: { full: purchaseStatusFullForm, context: purchaseStatusContextForm, mini: purchaseStatusMiniForm, lookup: purchaseStatusLookupForm },
  menu: purchaseStatusMenu,
} as IRecordTypeDefinition;
